var map = {
	"./belarus.svg": 9860,
	"./denmark.svg": 5246,
	"./estonia.svg": 2073,
	"./france.svg": 5057,
	"./lithuania.svg": 8357,
	"./norway.svg": 3298,
	"./poland.svg": 9292,
	"./russia.svg": 8403,
	"./uk.svg": 3748,
	"./ukraine.svg": 6023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7809;